import type { SearchInlineFeedbackProps } from './components/SearchInlineFeedback';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "SearchDiagnosticsView"*/ './lazyIndex'),
    { name: 'SearchDiagnosticsView' }
);

export const SearchInlineFeedback: LazyComponent<SearchInlineFeedbackProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.SearchInlineFeedback);
